


























































import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import DateRangePickerBase from '@/components/common/atoms/DateRangePickerBase.vue'
import { StudyData } from '@/mixins/requests/academy/StudyListApis.vue'
import { PeriodsData } from '@/mixins/requests/academy/StudyListApis.vue'

@Component({
  components: {
    ButtonBase,
    SelectBase,
    DateRangePickerBase,
  },
})
export default class StudyTable extends Vue {
  @Prop()
  private studyList!: StudyData[]

  @Prop()
  private onClickStudentComfirmButton!: (studyContentId: string) => void

  @Prop()
  private onClickAcademySummaryButton!: (studyContentId: string) => void

  private buttonColortype(isPresenceStudied: boolean): string {
    return isPresenceStudied ? '' : 'pointer-events-none'
  }
  private summaryColortype(study: StudyData): string {
    return study.isPresenceStudied && !study.isScoring ? '' : 'pointer-events-none'
  }

  private isSingleOptions: SelectOption[] = [
    { value: 'true', text: '1回' },
    { value: 'false', text: '複数' },
  ]

  private isTimeOptions: SelectOption[] = [
    { value: 'true', text: '時間' },
    { value: 'false', text: '任意' },
  ]

  private setDateRange(startDate: string, endDate: string) {
    return { startDate: startDate, endDate: endDate }
  }

  private setRangeInput(targetKey: number, range: PeriodsData) {
    this.studyList
      .filter((study: StudyData) => study.studyContentId === targetKey)
      .map((study: StudyData) => {
        study.periods.startDate = range.startDate
        study.periods.endDate = range.endDate
      })
  }
}
